<div class="center">
  <mat-spinner diameter="30" />
  <div>{{ title || "Loading..." }}</div>
</div>
